import * as PropTypes from 'prop-types';
import * as React from 'react';
import TableTab from './tab';

const TableHeader = ({ onConditionClick, selectedCondition }) =>
  (<div>
    <h2 className="heading-4 scaling-mt-2 mb-half">
      {I18n.t('js.transactionHistory.tableHeader')}
    </h2>
    <div className="tabbable">
      <ul className="nav-tabs">
        <TableTab
          condition="used"
          selectedCondition={selectedCondition}
          onConditionClick={condition => onConditionClick(condition)}
        />
        <TableTab
          condition="new"
          selectedCondition={selectedCondition}
          onConditionClick={condition => onConditionClick(condition)}
        />
      </ul>
    </div>
  </div>);

TableHeader.propTypes = {
  onConditionClick: PropTypes.func.isRequired,
  selectedCondition: PropTypes.string.isRequired,
};

export default TableHeader;



// WEBPACK FOOTER //
// ./javascripts/components/price_guide/transaction_history/table/header.jsx